import React, { useEffect, useState } from 'react';
import axios from '../../utils/axiosConfig';
import { useParams, Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { useSelector } from 'react-redux';

const SubscriptionAlertBanner = () => {
    const { slug } = useParams();
    const { isAuthenticated, user } = useSelector(state => state.auth);
    const [alertType, setAlertType] = useState(null); // 'past_due' | 'needs_activation'

    useEffect(() => {
        // Only run check if the user is authenticated and potentially an admin or staff
        if (!isAuthenticated || !user) return;

        let alive = true;
        const checkStatus = async () => {
            try {
                // If they have access to the dashboard, it's safe to check stats
                const res = await axios.get(`/${slug}/api/subscriptions/status`, { withCredentials: true });
                if (alive && res.data?.billingModel === 'subscription') {
                    if (res.data?.subscriptionStatus === 'past_due') {
                        setAlertType('past_due');
                    } else if (res.data?.subscriptionStatus !== 'active') {
                        setAlertType('needs_activation');
                    }
                }
            } catch (err) {
                // Ignore 403s if they are just customers
            }
        };
        checkStatus();
        return () => { alive = false; };
    }, [slug, isAuthenticated, user]);

    if (!alertType) return null;

    return (
        <div className={`text-white px-4 py-2.5 text-center text-xs md:text-sm font-bold w-full fixed top-0 z-[10000] flex justify-center items-center gap-2 shadow-lg ${alertType === 'past_due' ? 'bg-red-500' : 'bg-primary-orange'}`}>
            <AlertCircle size={16} className="shrink-0 text-white" />
            <span className="truncate">
                {alertType === 'past_due' 
                    ? "Tu suscripción mensual está pausada por falta de pago. Emisión de pases bloqueada." 
                    : "Para habilitar tu Salón deberás iniciar una suscripción (incluye 90 días de prueba gratis)."}
            </span>
            <Link to={`/${slug}/admin/billing`} className="underline ml-2 hover:text-white/80 shrink-0 border border-white/30 px-2 py-0.5 rounded-lg bg-white/10">
                {alertType === 'past_due' ? 'Pagar ahora' : 'Activar Ahora'}
            </Link>
        </div>
    );
};

export default SubscriptionAlertBanner;
